// src/constants/ApiConfig.js
// export const API_BASE_URL = 'http://127.0.0.1:8000/api/';
// export const IMAGE_BASE_URL = 'http://127.0.0.1:8000/images/';
// export const SABAHEBAT_DEV_URL = 'http://localhost:3000'; 
export const API_BASE_URL = 'https://sabahebat-api.mapskart.com.my/api/';
export const IMAGE_BASE_URL = 'https://sabahebat-api.mapskart.com.my/images/';
export const SABAHEBAT_DEV_URL = 'https://sabahebat-plantation.mapskart.com.my';
